<button (click)="openProjectsDialog()">
  <oph-icon name="plus-orange" [size]="18"></oph-icon>
  <span class="text">Task</span>
</button>
